/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum GenderType {
  Male = 'Male',
  Female = 'Female',
  Other = 'Other',
  Unknown = 'Unknown'
}
